import { gamePresentationOf } from "@softmax/web-features/coworlds";
import { matchRoute } from "@softmax/web-addresses";

import { gameTheaterQueryKeys } from "../../game-types";
import { type GamePageContext } from "../../game-types";

import { type AdmissionDecision } from "./admission.types";

function rootPresentationAdmission({
  url,
  corpusSlug,
}: {
  readonly url: URL;
  readonly corpusSlug: string;
}): AdmissionDecision | null {
  if (gameTheaterQueryKeys.some((key) => url.searchParams.has(key)))
    return { kind: "allowed" };

  switch (gamePresentationOf(corpusSlug).home) {
    case "desk":
      return { kind: "allowed", presentation: "desk" };
    case "store":
      return { kind: "allowed", presentation: "home" };
    default:
      return null;
  }
}

export function publicPresentationAdmission({
  url,
  game,
}: {
  readonly url: URL;
  readonly game: GamePageContext | null;
}): AdmissionDecision | null {
  const pathname = url.pathname.replace(/^\/unlisted(?=\/)/, "");
  const route = matchRoute(url.pathname);

  if (matchRoute(pathname).name === "retiredPaper")
    return { kind: "not-found" };

  if (game?.mode === "upload") return { kind: "allowed" };

  const isRoot = game !== null && pathname.split("/").length === 2;

  if (isRoot && url.searchParams.has("version")) return { kind: "allowed" };

  if (
    url.searchParams.get("view") === "lobby" &&
    ["watch", "game.home", "game.league"].includes(route.name)
  ) {
    return {
      kind: "navigate",
      navigation: { kind: "lobby" },
    };
  }

  const rootAdmission = isRoot
    ? rootPresentationAdmission({ url, corpusSlug: game.corpusSlug })
    : null;

  if (rootAdmission) return rootAdmission;

  if (["game.desk", "game.report"].includes(route.name))
    return { kind: "allowed" };

  return null;
}
